module.exports = __webpack_public_path__ + "static/media/HCMM865.92647650.jpg";